import Layout from '../components/layout/Layout'
import { Link } from 'react-router-dom'
import { ArrowUpRight, X } from 'lucide-react'
import { HandDrawnHighlight } from '../components/HandDrawnHighlight'
import { useState } from 'react'

const About = () => {
  const [showDanvasModal, setShowDanvasModal] = useState(false)

  const closeModal = () => {
    setShowDanvasModal(false)
  }

  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <div className="max-w-2xl">
          <h1 className="text-4xl font-bold text-foreground mb-6">Hello,</h1>
          <p className="text-foreground text-lg leading-relaxed">
            I'm an engineer exploring the future of{' '}
            <Link
              to="/thoughts/chibatore"
              className="inline-block border-b border-transparent hover:border-dashed hover:border-foreground transition-all duration-300 pb-[2px]"
            >
              <HandDrawnHighlight delay={0}>human body</HandDrawnHighlight>
            </Link>
            ,{' '}
            <HandDrawnHighlight delay={0.2}>innovation</HandDrawnHighlight>, and{' '}
            <HandDrawnHighlight delay={0.4}>philosophy</HandDrawnHighlight>. I create products, research ideas, and collaborate with startups and organizations to design solutions that are simple, meaningful, and accessible to everyone. I am passionate about finding simple solutions to the most complex problems.
          </p>
          <p className="mt-4">
            Learn more about my Software Consuting Company{' '}
            <Link
              to="https://setolab.com"
              className="inline-flex items-center px-2 py-0.5 rounded-full text-foreground text-[10px] font-semibold border border-foreground hover:bg-foreground hover:text-white transition-colors duration-300"
              target="_blank"
              rel="noopener noreferrer"
            >
              SETO LAB
              <ArrowUpRight size={12} className="ml-1" />
            </Link>
            {' '}or contact me directly via{' '}
            <a
              href="https://www.linkedin.com/in/sergey-tsibel-28334854/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground underline hover:text-foreground/80"
            >
              LinkedIn
            </a>
          </p>

          <div className="mt-16">
            <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-6">Previously</h2>
            <div className="space-y-8">
              <div className="grid grid-cols-[180px,1fr] gap-x-8 items-baseline">
                <p className="text-lg font-bold">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      setShowDanvasModal(true)
                    }}
                    className="hover:underline cursor-pointer"
                  >
                    Danvas
                  </a>
                </p>
                <div>
                  <p className="text-lg">CTO</p>
                  <p className="text-sm text-muted-foreground">2022–2024</p>
                </div>
              </div>

              <div className="grid grid-cols-[180px,1fr] gap-x-8 items-baseline">
                <p className="text-lg font-bold">
                  <a
                    href="https://saatchiart.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    SaatchiArt
                  </a>
                </p>
                <div>
                  <p className="text-lg">Head of Engineering</p>
                  <p className="text-sm text-muted-foreground">2019–2022</p>
                </div>
              </div>

              <div className="grid grid-cols-[180px,1fr] gap-x-8 items-baseline">
                <p className="text-lg font-bold group relative">
                  <span className="hover:line-through cursor-default">
                    Leaf Group
                  </span>
                  <span className="absolute left-0 -bottom-5 text-xs text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    Acquired by Graham Holdings
                  </span>
                </p>
                <div>
                  <p className="text-lg">Engineer</p>
                  <p className="text-sm text-muted-foreground">2015–2019</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showDanvasModal && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto"
          onClick={closeModal}
        >
          <div
            className="w-full max-w-2xl md:max-w-4xl lg:max-w-6xl relative flex items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 p-2 text-white hover:text-white/80 transition-colors rounded-full bg-black/50 hover:bg-black/70 z-50"
              aria-label="Close modal"
            >
              <X size={24} />
            </button>
            <video
              src="https://assets.setolab.com/danvas-promo-video.mp4"
              className="w-full h-auto max-h-[calc(100vh-4rem)]"
              controls
            />
          </div>
        </div>
      )}
    </Layout>
  )
}

export default About